module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--32.84db064e.png";